import { render, staticRenderFns } from "./CreateLocationCatalogue.vue?vue&type=template&id=0a576806&scoped=true&"
import script from "./CreateLocationCatalogue.vue?vue&type=script&lang=ts&"
export * from "./CreateLocationCatalogue.vue?vue&type=script&lang=ts&"
import style0 from "./CreateLocationCatalogue.vue?vue&type=style&index=0&id=0a576806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a576806",
  null
  
)

export default component.exports